// extracted by mini-css-extract-plugin
module.exports = {"container":"RecentUpdates_container__3uJzl","ribbon_drop":"RecentUpdates_ribbon_drop__YiPVy"};